// src/components/sections/ReviewsSection.jsx (ФИНАЛЬНАЯ ВЕРСИЯ)

import React, { useState } from 'react';
import './ReviewsSection.css';
import { useTranslation } from 'react-i18next'; 

// Переименовали константу для ясности
const INITIAL_VISIBLE_REVIEWS = 3;

function ReviewsSection({ reviewsData, onAddReviewClick }) {
  const { t, i18n } = useTranslation();

  // 1. ЛОГИКА - такая же, как в Services и Portfolio
  const [visibleCount, setVisibleCount] = useState(INITIAL_VISIBLE_REVIEWS);

  const dateOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };

  if (!Array.isArray(reviewsData) || reviewsData.length === 0) {
    return (
      <section className="reviews-section" id="reviews">
        <h2>{t('reviews.title')}</h2>
        <p className="no-reviews">{t('messages.error.reviewsEmpty')}</p>
        <button onClick={onAddReviewClick} className="add-review-button">{t('reviews.addReviewButton')}</button> 
      </section>
    );
  }
  
  const isExpanded = visibleCount >= reviewsData.length;
  const visibleReviews = reviewsData.slice(0, visibleCount);
  
  const handleToggleVisibility = () => {
    if (isExpanded) {
      setVisibleCount(INITIAL_VISIBLE_REVIEWS); // Свернуть
    } else {
      setVisibleCount(reviewsData.length); // Развернуть
    }
  };

  return (
    <section className="reviews-section" id="reviews">
      <h2>{t('reviews.title')}</h2>
      <div className="reviews-grid">
        {/* Используем 'visibleReviews' для отрисовки */}
        {visibleReviews.map((review) => ( 
          <div key={review.id} className="review-card">
            <p className="review-message">"{review.message}"</p>
            <div className="review-meta">
              <p className="review-author">{review.name}</p>
              {review.created_at && (
                  <p className="review-date">
                  {new Date(review.created_at).toLocaleDateString(i18n.language, dateOptions)}
                  </p>
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="reviews-buttons-container" style={{ textAlign: 'center', marginTop: '30px' }}>
        {/* Показываем кнопку 'Показать/Свернуть', если отзывов больше, чем показано изначально */}
        {reviewsData.length > INITIAL_VISIBLE_REVIEWS && (
          <button onClick={handleToggleVisibility} className="show-more-button">
            {isExpanded 
              ? t('reviews.showLessButton', 'Свернуть отзывы') 
              : t('reviews.showMoreButton', 'Показать все отзывы')}
          </button>
        )}
        
        <button onClick={onAddReviewClick} className="add-review-button" style={{ marginLeft: '15px' }}>
          {t('reviews.addReviewButton')}
        </button>
      </div>
    </section>
  );
}

export default ReviewsSection;